import { Box, Flex, Text, Button, Heading, Card } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const StudentPlanCheck = ({ message }) => {
    const navigate = useNavigate();
    const finance = useSelector(state => state.account.finance);

    return (
        <Box width="100%">
            <Card>
                <Flex direction="column" gap="3">
                    <Heading size="4">Subscription Status</Heading>

                    {finance?.status === 'active' ? (
                        <Flex direction="column" gap="2">
                            <Text>Current Plan: {finance.subscription.plan}</Text>
                            <Text>Status: Active</Text>
                            <Text>Next Payment: {new Date(finance.subscription.nextPaymentDate).toLocaleDateString()}</Text>
                        </Flex>
                    ) : (
                        <Flex direction="column" gap="2" align="start">
                            <Text color="gray">{message || 'No active subscription'}</Text>
                            <Button variant="solid" color="blue" onClick={() => navigate('/student/payments')}>
                                Subscribe Now
                            </Button>
                        </Flex>
                    )}
                </Flex>
            </Card>
        </Box>
    );
};

export default StudentPlanCheck;
